import { updateObjectState, updateState } from '../helpers';

import { ACTIONS, DEALERS_PARAMS_FIELDS, STORE_FIELDS, VALUE_FIELDS } from './constants';
import { ERRORS_STATE, INITIAL_STATE } from './initialState';

export default function (state = INITIAL_STATE, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.SET_CAR_INSTANCE: {
      const { carInstance } = payload;

      state.fetch = false;
      state.isPatching = false;

      return updateObjectState({ name: STORE_FIELDS.CAR_INSTANCE, payload: carInstance, state });
    }

    case ACTIONS.SET_FETCH_CAR_INSTANCE:
      return updateState({ payload: { [STORE_FIELDS.FETCH]: payload }, state });

    case ACTIONS.SET_FETCH_CAR_INFO:
      return updateState({ payload: { [STORE_FIELDS.CAR_INFO_FETCH]: payload }, state });

    case ACTIONS.SET_PATCHIG_CAR_INSTANCE:
      return updateState({ payload: { [STORE_FIELDS.IS_PATCHING]: payload }, state });

    case ACTIONS.SET_ERROR_CAR_INSTANCE:
      return updateState({
        payload: { [STORE_FIELDS.ERROR]: payload, [STORE_FIELDS.FETCH]: false },
        state,
      });

    case ACTIONS.UPDATE_ERRORS_CAR_INSTANCE: {
      const { errors } = payload;

      return updateObjectState({ name: STORE_FIELDS.ERRORS, payload: errors, state });
    }

    case ACTIONS.DROP_ERRORS_CAR_INSTANCE:
      return updateObjectState({ name: STORE_FIELDS.ERRORS, payload: ERRORS_STATE, state });

    case ACTIONS.DROP_ONE_ERROR_CAR_INSTANCE: {
      const { catalog, name } = payload;

      const error = { [name]: '' };
      let errors = error;

      if (catalog) {
        errors = { [catalog]: error };
      }

      return updateObjectState({ name: STORE_FIELDS.ERRORS, payload: errors, state });
    }

    case ACTIONS.VALIDATE_CAR_INSTANCE:
      return updateState({ payload, state });

    case ACTIONS.FORCE_VALIDATE_CAR_INSTANCE: {
      const { forceValidate: stateForceValidate } = state;

      return { ...state, forceValidate: stateForceValidate + 1 };
    }

    case ACTIONS.SCROLL_TO_INSTANCE:
      return updateState({ payload, state });

    case ACTIONS.CLEAR_SCROLL_TO_INSTANCE:
      return updateState({ payload: { [STORE_FIELDS.SCROLL_TO]: null }, state });

    case ACTIONS.CLEAR_CAR_INSTANCE: {
      const {
        [STORE_FIELDS.HIDDEN_FIELDS]: hiddenFields,
        [STORE_FIELDS.IS_OPEN_BLOCK]: isOpenBlock,
        [STORE_FIELDS.IS_OPEN_DETAILS]: isOpenDetails,
        [STORE_FIELDS.REQUIRED_FIELDS]: requiredFields,
      } = state;

      return {
        ...INITIAL_STATE,
        [STORE_FIELDS.HIDDEN_FIELDS]: [...hiddenFields],
        [STORE_FIELDS.IS_OPEN_BLOCK]: isOpenBlock,
        [STORE_FIELDS.IS_OPEN_DETAILS]: isOpenDetails,
        [STORE_FIELDS.REQUIRED_FIELDS]: [...requiredFields],
      };
    }

    case ACTIONS.UPDATE_CAR_INSTANCE_ID:
      return updateObjectState({
        name: STORE_FIELDS.CAR_INSTANCE,
        payload: { [VALUE_FIELDS.ID]: payload },
        state,
      });

    case ACTIONS.PATCH_IS_NEW:
      return updateState({ payload: { [STORE_FIELDS.PATCH_IS_NEW]: payload }, state });

    case ACTIONS.CHANGE_DEALERS_PARAMS: {
      const { dealersParams } = payload;

      return updateObjectState({
        name: STORE_FIELDS.DEALERS_PARAMS,
        payload: dealersParams,
        state,
      });
    }

    case ACTIONS.SET_FETCH_DEALERS_PARAMS:
      return updateObjectState({
        name: STORE_FIELDS.DEALERS_PARAMS,
        payload: { [DEALERS_PARAMS_FIELDS.FETCH_DEALERS_PARAMS]: payload },
        state,
      });

    case ACTIONS.SET_IMAGE: {
      let { image } = payload;

      image ||= null;

      return updateObjectState({
        name: STORE_FIELDS.CAR_INSTANCE,
        payload: { [VALUE_FIELDS.IMAGE]: image },
        state,
      });
    }

    case ACTIONS.DECLINE_DROP_ERRORS:
      return updateState({ payload, state });

    case ACTIONS.OPEN_BLOCK:
    case ACTIONS.CLOSE_BLOCK:
      return updateState({
        payload: { [STORE_FIELDS.IS_OPEN_BLOCK]: type === ACTIONS.OPEN_BLOCK },
        state,
      });

    case ACTIONS.OPEN_DETAILS:
    case ACTIONS.CLOSE_DETAILS:
      return updateState({
        payload: { [STORE_FIELDS.IS_OPEN_DETAILS]: type === ACTIONS.OPEN_DETAILS },
        state,
      });

    case ACTIONS.DISABLE:
    case ACTIONS.ENABLE:
      return updateState({
        payload: { [STORE_FIELDS.IS_DISABLE]: type === ACTIONS.DISABLE },
        state,
      });

    case ACTIONS.SET_COLLAPSABLE:
      return updateState({ payload: { [STORE_FIELDS.IS_COLLAPSABLE]: payload }, state });

    case ACTIONS.SET_CAR_REQUIRED_FIELDS:
      return updateState({
        payload: { [STORE_FIELDS.REQUIRED_FIELDS]: (payload || []).sort() },
        state,
      });

    case ACTIONS.SET_CAR_HIDDEN_FIELDS:
      return updateState({
        payload: { [STORE_FIELDS.HIDDEN_FIELDS]: (payload || []).sort() },
        state,
      });

    case ACTIONS.SET_CAR_DISABLE_FIELDS:
      return updateState({
        payload: { [STORE_FIELDS.DISABLE_FIELDS]: (payload || []).sort() },
        state,
      });

    case ACTIONS.UPDATE_NESTED_VALUES: {
      const { field, values } = payload;

      const {
        [STORE_FIELDS.CAR_INSTANCE]: { [field]: fieldState },
      } = state;
      const newFieldState = { [field]: updateState({ payload: values, state: fieldState }) };

      return updateObjectState({ name: STORE_FIELDS.CAR_INSTANCE, payload: newFieldState, state });
    }

    case ACTIONS.UPDATE_NESTED_ERRORS: {
      const { errors, field } = payload;

      const {
        [STORE_FIELDS.ERRORS]: { [field]: fieldState },
      } = state;
      const newFieldState = { [field]: updateState({ payload: errors, state: fieldState }) };

      return updateObjectState({ name: STORE_FIELDS.ERRORS, payload: newFieldState, state });
    }

    default:
      return state;
  }
}

export * from './actions';
